import React, { useEffect, useState, lazy, Suspense } from "react";
import "./style.scss";
import GoBack from "../../../assets/GoBackApp.svg";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import Button from "shared/ui/button";
import { useStore } from "zustand";
import { onboardStore } from "entities/onboard/model/onboardModel";
import { accountStore } from "entities/account";
import { useTranslation } from "react-i18next";
import Loading from "widgets/loading";

const PhoneInput = lazy(() =>
  import("react-international-phone").then((mod) => ({
    default: mod.PhoneInput,
  }))
);

const isPhoneValid = async (phone: string) => {
  try {
    const { PhoneNumberUtil } = await import("google-libphonenumber");
    const phoneUtil = PhoneNumberUtil.getInstance();
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch {
    return false;
  }
};

export const ChangePhonePage = () => {
  const [phone, setPhone] = useState<string>("");
  const [isValid, setIsValid] = useState(false);
  const { isLoading, requestChangePhone } = useStore(accountStore);
  const { i18n, t: err } = useTranslation("errors");
  const { t: y } = useTranslation("yup");
  const { t } = useTranslation("app");

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(PATH_LIST.personal);
  };

  useEffect(() => {
    const validate = async () => {
      if (!phone) {
        setIsValid(false);
        return;
      }
      const valid = await isPhoneValid(phone);
      setIsValid(valid);
    };

    validate();
  }, [phone]);

  const onSubmit = (e: any) => {
    e.preventDefault();
    const clearPhone = phone.replace(/\D/g, "");

    requestChangePhone(
      { phone: clearPhone, language: i18n.language },
      err,
      () => {
        navigate(PATH_LIST.verifyChangedPhone);
      }
    );
  };

  return (
    <div className="change-phone">
      <div className="change-phone-header">
        <img
          className="go-back-portfolio"
          onClick={handleNavigate}
          src={GoBack}
          alt="Go Back"
        />
      </div>
      <div className="change-phone-main">
        <p>{t("yourPhone")}</p>
        <span>{t("weWillSendVerification")}</span>

        <form className="phoneForm form-change-phone" onSubmit={onSubmit}>
          <label>{t("phoneNumber")}</label>

          <Suspense fallback={<Loading />}>
            <PhoneInput
              defaultCountry={"am"}
              value={phone}
              onChange={(v: string) => setPhone(v)}
              inputProps={{ autoFocus: true, value: phone }}
            />
          </Suspense>

          {!isValid && <p className="validation">{y("phoneNotValid")}</p>}
          <div className="btn-wrapper">
            <Button
              className="phoneNumberBtn"
              children={t("continue")}
              variant="dark"
              disabled={!isValid || isLoading}
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
